module.exports = __webpack_public_path__ + "static/media/workday.41ed49c5.png";